import { createBrowserRouter, Navigate } from "react-router-dom";
import { CssBaseline, ThemeProvider } from "@mui/material";
import darkTheme from "../themes/mainTheme";
import customTheme from "../themes/loginThemes";
import MainLayout from "../layouts/MainLayout";
import Login from "../pages/Login";
import HomeLayout from "../layouts/HomeLayout";
import CartLayout from "../layouts/CartLayout";
import OrderLayout from "../layouts/OrderLayout";
import HomePage from "../pages/HomePage";
import CartPage from "../pages/CartPage";
import OrderPage from "../pages/OrderPage";
import NotFoundPage from "../pages/NotFoundPage";
import ProtectedRoute from "./ProtectedRoutes";
import StockLayout from "../layouts/StockLayout";
import ReportLayout from "../layouts/ReportLayout";
import { SalesPersonIdProvider } from "../context/SalesPersonContext";
import StockCardPage from "../pages/StockCardPage";

export const routes = createBrowserRouter([
  // Login route
  {
    path: "/login",
    element: (
      <ThemeProvider theme={customTheme}>
        <CssBaseline />
        <Login />
      </ThemeProvider>
    ),
  },
  // Redirect root to /home
  // {
  //   path: "/",
  //   element: <Navigate to="/home" replace />,
  // },
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <SalesPersonIdProvider>
          <ThemeProvider theme={darkTheme}>
            <CssBaseline />
            <MainLayout />
          </ThemeProvider>
        </SalesPersonIdProvider>
      </ProtectedRoute>
    ),
    children: [
      {
        path: "home",
        element: <HomeLayout />,
        children: [{ index: true, element: <HomePage /> }],
      },
      {
        path: "cart",
        element: <CartLayout />,
        children: [{ index: true, element: <CartPage /> }],
      },
      {
        path: "order",
        element: <OrderLayout />,
        children: [{ index: true, element: <OrderPage /> }],
      },
      {
        path: "stock",
        element: <StockLayout />,
      },
      {
        path: "report",
        element: <ReportLayout />,
      },
    ],
  },
  {
    path: "/details/:styleNumber",
    element: <ProtectedRoute><StockCardPage /></ProtectedRoute>
  },
  {
    path: "*",
    element: <NotFoundPage />,
  }
]);
